import { dropboxConfigured } from '../pickers/dropbox';
import { googleDriveConfigured } from '../pickers/googleDrive';
import { oneDriveConfigured } from '../pickers/oneDrive';
import type { RemoteSource } from '../pickers/types';

interface Props {
  onPick: (source: RemoteSource) => void;
  busy: boolean;
}

const DropboxIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true" fill="#0061FF">
    <path d="M6 2 0 6l6 4 6-4-6-4Zm12 0-6 4 6 4 6-4-6-4ZM0 14l6 4 6-4-6-4-6 4Zm18-4-6 4 6 4 6-4-6-4ZM6 19.2l6 4 6-4-6-3.6-6 3.6Z" />
  </svg>
);

const DriveIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <path fill="#0F9D58" d="M8.4 2 1 15h6.6l6.4-11-2.4-2H8.4Z" />
    <path fill="#FFCD40" d="M16 15h7L16.6 4h-5.2L16 15Z" />
    <path fill="#4285F4" d="m1 15 3.2 5.5h15.6L23 15H1Z" />
  </svg>
);

const OneDriveIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true" fill="#0364B8">
    <path d="M10.6 5.2a5.6 5.6 0 0 1 5.1 3.3 4.3 4.3 0 0 1 4 3.3 3.6 3.6 0 0 1-.9 7.1H6a4.5 4.5 0 0 1-.9-8.9 5.6 5.6 0 0 1 5.5-4.8Z" />
  </svg>
);

const DEVICE_HINT = 'Sign in with the provider and pick your HEIC photos';

export function SourceBar({ onPick, busy }: Props) {
  const providers = [
    { id: 'dropbox' as const, label: 'Dropbox', configured: dropboxConfigured, icon: <DropboxIcon /> },
    { id: 'google-drive' as const, label: 'Google Drive', configured: googleDriveConfigured, icon: <DriveIcon /> },
    { id: 'onedrive' as const, label: 'OneDrive', configured: oneDriveConfigured, icon: <OneDriveIcon /> },
  ];

  return (
    <div className="sources">
      {providers.map((provider) => (
        <button
          key={provider.id}
          type="button"
          className="source-btn"
          disabled={busy || !provider.configured}
          title={provider.configured ? DEVICE_HINT : provider.label + ' is not configured on this deployment'}
          onClick={() => onPick(provider.id)}
        >
          {provider.icon}
          {provider.label}
        </button>
      ))}
    </div>
  );
}
